import Layout from '@modules/layout/containers/Layout';
import Home from '@modules/pages/home';

const App = () => {
  return (
    <Layout>
      <Home />
    </Layout>
  );
};

export default App;
